const dndTypes = {
    NODE: 'neos-tree-node',
    MULTISELECT: 'neos-multiselect-value'
};
export default dndTypes;
